import React, { useState } from "react";
import Header from "./Header";
import WelcomeSection from "./WelcomeSection";
import ToggleView from "./ToggleView";
import EnrolledSection from "./EnrolledSection";
import ProgramsGrid from "./ProgramsGrid";
import Footer from "./Footer";
import { programs } from "./data/programs";
import "./styles/Styles.css";
import EnrollModal from "./EnrollmentModal";

function CourseMain() {
  const [isEnrolledView, setIsEnrolledView] = useState(true);

  return (
    <div className="">
      <Header />

      <div className="container">
        <WelcomeSection />

        <div id="notEnrolledView">
          <div className="programs-section">
            <h2 className="section-title">
              <i className="fas fa-gem"></i> Available Programs
            </h2>
            <ProgramsGrid
              programs={programs}
              // isEnrolledView={isEnrolledView}
              onEnroll={setIsEnrolledView}
            />

            <EnrollModal />
          </div>
        </div>
      </div>

      <Footer />
    </div>
  );
}

export default CourseMain;
